{
  "positions": {
    "typesAssets": {
      "stocks": "Акции",
      "options": "Опционы"
    }
  }
}
